module.exports = __webpack_public_path__ + "img/resized-cover6.92a5d329.png";